module.exports = "/packs/chevron-right-gray-5593ed00c7dc3a9f10520fe36b07b31e.svg";